import apiClient from '../../../Services/ApiClient';

export const checkSUKLCredentialsAvailability = async () => {
	const { data: credData } = await apiClient.get(
		'/erecept/lekovy-zaznam/wizard/sukl-requirements/tree',
	);

	return credData.some(({ id }: { id: string }) => id === 'suklCredentials');
};
